<template>
  <div>
    <topnav ></topnav>
    <div v-if="page" class="tech-head">
      <div class="tech-top-img">
          <img v-if="page.mainImage.imageURL" :src="page.mainImage.imageURL" />
          <img v-else src="../assets/tech8.jpg" />
        </div>
        <div
          class="tech-top-frame">
          <h1 class="title-page">{{ page.title }}</h1>
          <br />
        </div>

    </div>
    <div v-if="page" class="w700" v-html="page.body"></div>
    <botfooter ></botfooter>
  </div>
</template>

<script>
import Botfooter from "@/components/Botfooter.vue";
import Topnav from "@/components/Topnav.vue";


export default {
  components: {
    Topnav,
    Botfooter,
  },
  data() {
    return {
      page: {
        title: '',
        mainImage: {
          imageURL: '',
        },
        body: ''
      }
    };
  },
  created() {
    this.loadPageData();
  },
  methods: {
    loadPageData() {
      const slug = this.$route.path.split('/').pop();
      console.log(slug);
      console.log(this.$local.pages);
      // Assuming a function fetchPageData(slug) that returns a promise with the page data
      const foundPage = this.$local.pages.find(page => page.slug === slug);
      
      if (foundPage) {
        this.page = foundPage;
      } else {
        // Fallback for when page is not found
        this.page = {
          title: 'Page Not Found',
          image: '',
          body: '<p>The requested page could not be found.</p>'
        };
      }
    }
  },
  name: "GoogleCloud",
};
</script>

<style scoped>
.title-page {
  border:none;
  padding:0;
  font-size: 48px;
  font-weight: 600;
  color: #000;
  text-align: center;
}
</style>